// extracted by css-extract-rspack-plugin
export default {"cls1":"CurrentPaperRow-cls1_wU5","cls2":"CurrentPaperRow-cls2_Zaq CurrentPaperRow-cls1_wU5"};